import React from "react";
import { Link } from "react-router-dom";

/**
 * Brand logo — always renders the official AdiYogi Handcrafts mark from /adiyogi-logo.png.
 * Sizes:
 *   - "sm"  compact (used inside mobile header, checkout progress, order confirmation icons)
 *   - "md"  default header/footer
 *   - "lg"  hero-adjacent, About page
 */
export default function Logo({ size = "md", showWordmark = false, linkTo = "/", className = "" }) {
  const dim = size === "sm" ? "h-9" : size === "lg" ? "h-16 md:h-20" : "h-11 md:h-12";
  const img = (
    <img
      src="/adiyogi-logo.png"
      alt="AdiYogi Handcrafts"
      className={`${dim} w-auto object-contain ${className}`}
      loading="eager"
      decoding="async"
    />
  );
  const inner = showWordmark ? (
    <span className="flex items-center gap-2">
      {img}
      <span className="hidden md:inline leading-none">
        <span className="block font-serif text-lg tracking-tight">AdiYogi</span>
        <span className="block text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Handcrafts</span>
      </span>
    </span>
  ) : img;
  return linkTo ? (
    <Link to={linkTo} data-testid="brand-logo" className="shrink-0 flex items-center">{inner}</Link>
  ) : (
    <span className="shrink-0 flex items-center">{inner}</span>
  );
}
